import { SAVE_ASSURANCE } from './actionTypes'
import { AssuranceTypes } from './types'
import { AssuranceModalModel } from '../../../types/assurance/assuranceModalModel'

export const saveAssurance = (assuranceData: AssuranceModalModel): AssuranceTypes => {
	return (
		{
			type: SAVE_ASSURANCE,
			payload: assuranceData
		}
	)
}
